export default __webpack_public_path__ + "static/media/pin-question-hover.179ef837.wav";